import { LineController } from 'chart.js'

class SuperDuperLineController extends LineController {
    getLabelAndValue(index) {
      const meta = this.getMeta()
      if (index === -1) {
        const pt = meta._pt
        const vScale = meta.vScale
        return {
          label: 'interpolated',
          value: vScale.getValueForPixel(pt.y)
        }
      } else {
        return {
          label: 'interpolated',
          value: meta.data[index].parsed.y
        }
      }
      // return super.getLabelAndValue(index);
    }
  }

SuperDuperLineController.id = 'SuperDuperLine'
SuperDuperLineController.defaults = LineController.defaults

export default SuperDuperLineController
